import { FilterComponent } from './filters';
import { getFilterComponent } from './@arch/getFilterComponent';
import React from 'react';
import { TableFilter } from '@ui/table-modifier';
import { UpdateQueryParams } from '@hooks';

import { DynamicFilter, SonarObjectType } from '@sonar-software/sonar-ts-types';

export interface FilterDisplayProps {
	componentMapper?: (filter: Omit<TableFilter, 'label'>) => FilterComponent;
	displayAsTag?: boolean;
	filter: TableFilter;
	filterParams: DynamicFilter;
	sonarObjectId: number | null | undefined;
	sonarObjectType: SonarObjectType | null | undefined;
	updateFilterParams: UpdateQueryParams<DynamicFilter>;
}

export const FilterDisplay: React.FC<FilterDisplayProps> = ({
	componentMapper = getFilterComponent,
	displayAsTag,
	filter,
	filterParams,
	sonarObjectId,
	sonarObjectType,
	updateFilterParams
}) => {
	const { filterComponent, filterFormat, filterId, filterLabel, filterMetadata } = filter;
	const FilterDisplayComponent = filterComponent ?? componentMapper(filter);

	if (!FilterDisplayComponent) {
		return null;
	}

	return (
		<FilterDisplayComponent
			displayAsTag={ displayAsTag }
			format={ filterFormat }
			id={ filterId }
			key={ filterId }
			label={ filterLabel }
			metadata={ filterMetadata }
			onChange={ updateFilterParams }
			params={ filterParams }
			sonarObjectId={ sonarObjectId }
			sonarObjectType={ sonarObjectType }
			value={ filterParams[ filterId ]?.value as Array<string> } />
	);
};
